import React from "react";
import { FaArrowLeft, FaBars } from "react-icons/fa";
import * as SCREENS from "../constants/screens";
import { useBlueBody } from "../hooks/useBlueBody";

import CurrencyInput from "./currency-input";

const minVehicles = 7000;
const minHabitation = 70000;

export default function Credit({ dataManager, sidebarManager }) {
  const { data, setData } = dataManager;
  const { openSidebar } = sidebarManager;
  useBlueBody();

  function prevScreen() {
    setData({ ...data, screen: SCREENS.FINALITY });
  }

  function nextScreen() {
    const screen = data.associateMode ? SCREENS.RESULTS : SCREENS.PHONE;
    const { credit, creditMessage } = checkCredit();

    setData({
      ...data,
      credit: credit,
      creditMessage: creditMessage,
      results: calculateResult(credit),
      screen: screen,
    });
  }

  const checkCredit = () => {
    let credit = data.credit;
    let creditMessage = "";

    if (data.category < 4 && data.credit < minVehicles) {
      credit = 7000;
      creditMessage = `O valor do crédito foi alterado para R$ 7.000,00 (valor mínimo de crédito para ${data.finality.toLowerCase()}).`;
    } else if (data.category === 4 && data.credit < minHabitation) {
      credit = 70000;
      creditMessage = `O valor do crédito foi alterado para R$ 70.000,00 (valor mínimo de crédito para ${data.finality.toLowerCase()}).`;
    }

    return { credit, creditMessage };
  };

  function calculateResult(credit) {
    const terms =
      data.category === 1
        ? [24, 36, 48, 60]
        : data.category === 2
        ? [36, 48, 60, 72]
        : data.category === 3
        ? [48, 60, 84, 120]
        : data.category === 4
        ? [120, 144, 168, 200]
        : null;

    const tax = data.category === 4 ? 24.5 : credit > 34000 ? 20.8 : 28.5;

    const result = [];
    terms.forEach((item) => {
      const termValue = (credit * (1 + tax / 100)) / item;
      result.push({ term: item, termValue: termValue });
    });

    return result;
  }

  function setCredit(event, value) {
    event.preventDefault();
    setData({ ...data, credit: value });
  }

  const isCreditValid = () => {
    if (data.category < 4 && data.credit < minVehicles) {
      return `O valor mínimo de crédito para ${data.finality.toLowerCase()} é de R$ 7.000,00.`;
    } else if (data.category === 4 && data.credit < minHabitation) {
      return `O valor mínimo de crédito para ${data.finality.toLowerCase()} é de R$ 70.000,00.`;
    }

    return "";
  };

  return (
    <section className="administrators-screen">
      <div className="container mb-5">
        <div className="row justify-content-between align-items-center">
          <div className="col-auto">
            <FaArrowLeft
              role="button"
              className="icon-bar"
              onClick={prevScreen}
            />
          </div>
          <div className="col-8">
            <div className="progress">
              <div
                className="progress-bar"
                style={{ width: "60%" }}
                role="progressbar"
                aria-label="Progress Bar"
                aria-valuenow="60"
                aria-valuemin="0"
                aria-valuemax="100"
              ></div>
            </div>
          </div>
          <div className="col-auto">
            <FaBars role="button" className="icon-bar" onClick={openSidebar} />
          </div>
        </div>
      </div>
      <div className="container mb-5">
        <h1>Qual o valor de crédito?</h1>
        <h2>Digite abaixo o valor desejado.</h2>
      </div>
      <div className="bottom-panel container">
        <CurrencyInput
          type="tel"
          value={data.credit}
          placeholder="R$ 0,00"
          className="form-control mb-2"
          max={9999999}
          onChange={setCredit}
        />
        {isCreditValid() !== "" ? (
          <div className="alert alert-primary mb-2" role="alert">
            {isCreditValid()}
          </div>
        ) : null}
        <button className="btn btn-secondary mt-auto" onClick={nextScreen}>
          Continuar
        </button>
      </div>
    </section>
  );
}
